import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import React, { Component } from 'react';

import SnackDisplay from './SnackDisplay';
import { SnackContain } from './Styled';
import { clearMessage } from 'actions/messages';
import Conditional from '../../Conditional';

const Root = document.getElementById('root-contain');

export class SnackBar extends Component {
  constructor(props) {
    super(props);

    this.getMessage = this.getMessage.bind(this);
    this.onMessageHide = this.onMessageHide.bind(this);
  }

  onMessageHide() {
    const { clearMessage } = this.props;
    clearMessage();
  }

  getMessage() {
    const { messages } = this.props;

    return messages[0];
  }

  render() {
    const { lastUpdated } = this.props;
    const { message } = this.getMessage() || {};

    return ReactDOM.createPortal(
      <SnackContain>
        <Conditional show={message}>
          <SnackDisplay onMessageHide={this.onMessageHide} lastUpdated={lastUpdated} message={message} />
        </Conditional>
      </SnackContain>,
      Root
    );
  }
}

const mapDispatchToProps = { clearMessage };

const mapStateToProps = ({ messages }) => ({
  messages: messages.items,
  lastUpdated: messages.lastUpdated
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SnackBar);
